import { RootState } from 'store/root-reducer';

export const certificateSummarySelector = ({ certificate }: RootState) => certificate.summary;
export const certificateOptionSelector = ({ certificate }: RootState) => certificate.options;
